import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const I18nContext = createContext(null);
const STORAGE_KEY = "talabya_lang_v1";

// Dictionary — only key top-level strings; body content stays Arabic
const DICT = {
  ar: {
    "brand.tagline": "توصيل الطعام في ليبيا",
    "nav.login": "تسجيل الدخول",
    "nav.register": "إنشاء حساب",
    "nav.cart": "السلة",
    "nav.orders": "طلباتي",
    "nav.admin": "لوحة التحكم",
    "nav.driver": "طلبية مان",
    "nav.branches": "الفروع",
    "nav.logout": "تسجيل الخروج",
    "nav.install": "تثبيت التطبيق",
    "nav.download": "حمّل التطبيق",
    "landing.title1": "طلبك،",
    "landing.title2": "أسرع مما تتخيل",
    "landing.badge": "منصة توصيل الطعام #1 في ليبيا",
    "landing.cta.order": "اطلب الآن",
    "landing.cta.driver": "كن سائق طلبية",
    "landing.why": "لماذا طلبية؟",
    "landing.feature.speed.t": "توصيل سريع",
    "landing.feature.speed.d": "نضمن وصول طلبك ساخناً وطازجاً خلال 30 دقيقة أو أقل",
    "landing.feature.track.t": "تتبع مباشر",
    "landing.feature.track.d": "تابع طلبك لحظة بلحظة على الخريطة من المطعم حتى حوشك",
    "landing.feature.pay.t": "دفع آمن",
    "landing.feature.pay.d": "ادفع نقداً عند الاستلام أو استخدم بطاقتك — كلها آمنة",
    "landing.footer": "© 2026 طلبية · صُنع بحُب في ليبيا 🇱🇾",
    "home.welcome": "أهلاً بك في طلبية",
    "home.title": "ماذا نُوصلك اليوم؟",
    "home.branch_label": "الفرع المختار",
    "home.subtitle": "اختر طريقة الاستلام وابدأ الطلب",
    "home.delivery": "توصيل للعنوان",
    "home.pickup": "استلام من المحل",
    "home.search": "ابحث عن وجبة...",
    "home.all": "الكل",
    "home.no_results": "لا توجد نتائج",
    "home.add": "+ إضافة",
    "home.view_cart": "عرض السلة",
    "cart.title": "سلة الطلبات",
    "cart.empty.t": "سلتك فارغة",
    "cart.empty.d": "أضف بعض الوجبات الشهية للبدء",
    "cart.browse": "تصفح المنيو",
    "cart.clear": "إفراغ السلة",
    "cart.subtotal": "المجموع الفرعي",
    "cart.fee": "رسوم التوصيل",
    "cart.total": "الإجمالي",
    "cart.checkout": "متابعة إلى الدفع",
    "checkout.title": "إتمام الطلب",
    "checkout.place": "تأكيد الطلب",
    "orders.title": "طلباتي",
    "orders.none": "لا يوجد طلبات بعد",
    "orders.start": "ابدأ الطلب",
    "orders.rate": "قيّم الطلب",
    "orders.rated": "مُقيَّم",
    "settings.language": "اللغة",
    "common.loading": "جاري التحميل...",
    "common.cancel": "إلغاء",
    "common.save": "حفظ",
    "common.confirm": "تأكيد",
    "common.close": "إغلاق",
    "common.currency": "د.ل",
  },
  en: {
    "brand.tagline": "Food delivery in Libya",
    "nav.login": "Login",
    "nav.register": "Sign up",
    "nav.cart": "Cart",
    "nav.orders": "My orders",
    "nav.admin": "Dashboard",
    "nav.driver": "Talabya Man",
    "nav.branches": "Branches",
    "nav.logout": "Logout",
    "nav.install": "Install app",
    "nav.download": "Download app",
    "landing.title1": "Your order,",
    "landing.title2": "faster than you imagine",
    "landing.badge": "Libya's #1 food delivery platform",
    "landing.cta.order": "Order now",
    "landing.cta.driver": "Become a driver",
    "landing.why": "Why Talabya?",
    "landing.feature.speed.t": "Fast delivery",
    "landing.feature.speed.d": "We guarantee hot & fresh in 30 minutes or less",
    "landing.feature.track.t": "Live tracking",
    "landing.feature.track.d": "Follow your order live on the map from the restaurant to your door",
    "landing.feature.pay.t": "Secure payment",
    "landing.feature.pay.d": "Pay cash on delivery or use your card — all secure",
    "landing.footer": "© 2026 Talabya · Made with love in Libya 🇱🇾",
    "home.welcome": "Welcome to Talabya",
    "home.title": "What shall we deliver today?",
    "home.branch_label": "Selected branch",
    "home.subtitle": "Choose your fulfillment method and start ordering",
    "home.delivery": "Delivery to address",
    "home.pickup": "Pick up from restaurant",
    "home.search": "Search meals...",
    "home.all": "All",
    "home.no_results": "No results",
    "home.add": "+ Add",
    "home.view_cart": "View cart",
    "cart.title": "Your cart",
    "cart.empty.t": "Your cart is empty",
    "cart.empty.d": "Add some tasty meals to get started",
    "cart.browse": "Browse menu",
    "cart.clear": "Clear cart",
    "cart.subtotal": "Subtotal",
    "cart.fee": "Delivery fee",
    "cart.total": "Total",
    "cart.checkout": "Proceed to checkout",
    "checkout.title": "Checkout",
    "checkout.place": "Place order",
    "orders.title": "My orders",
    "orders.none": "No orders yet",
    "orders.start": "Start ordering",
    "orders.rate": "Rate order",
    "orders.rated": "Rated",
    "settings.language": "Language",
    "common.loading": "Loading...",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.confirm": "Confirm",
    "common.close": "Close",
    "common.currency": "LYD",
  },
};

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || "ar"; }
    catch { return "ar"; }
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
    document.documentElement.setAttribute("lang", l);
    document.documentElement.setAttribute("dir", l === "ar" ? "rtl" : "ltr");
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
  }, [lang]);

  const t = useCallback((key, fallback) => {
    const dict = DICT[lang] || DICT.ar;
    return dict[key] || fallback || key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, isRtl: lang === "ar" }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() { return useContext(I18nContext); }
export function useT() { return useContext(I18nContext).t; }
